import type { FormInstance }   from 'antd';
import React                   from 'react';
import { Form }                from 'antd';
import { Divider }             from 'antd';
import Row                     from 'components/App/Row';
import { Col }                 from 'antd';
import currentSession          from 'utils/currentSession';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import Input                   from 'components/App/IntlInput';
import InputPassword           from 'components/App/IntlInputPassword';
import Select                  from 'components/App/IntlSelect';
import { EN, FR }              from 'constants/Languages';
import handleFormError         from 'utils/handleFormError';
import type { RefObject }      from 'react';
import { AppFormComponent }    from 'components/App/AppForm';
import UserModel               from 'models/UserModel';
import UserMeModel             from 'models/UserMeModel';

const { Option } = Select;

interface AccountFormProps {
  model: UserModel;
}

class AccountForm extends AppFormComponent<AccountFormProps> {
  public formRef: RefObject<FormInstance> = React.createRef<FormInstance>();

  public componentDidMount() {
    const { model } = this.props;

    this.formRef.current?.setFieldsValue({
      email: model.email,
      languagePreference: model.languagePreference,
      plainPassword: undefined,
      plainPasswordConfirmation: undefined,
    });
  }

  public render() {
    return (
      <Form ref={this.formRef}>
        <div style={{ display: currentSession.isAdminOrSupport ? 'block' : 'none' }}>
          <Row>
            <Col span={24}>
              <Divider />
              <h3>
                <FormattedMessageWrapper id="Modifier mon email" />
              </h3>
            </Col>
            <Col lg={12} md={24}>
              <Form.Item
                // help={getFieldError('email') || ''}
                // validateStatus={getFieldError('email') ? 'error' : ''}
                label={<FormattedMessageWrapper id="Email" />}
                labelCol={{ span: 24 }}
                name="email"
                rules={[
                  {
                    message: <FormattedMessageWrapper id="Information manquante" />,
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </div>

        <Row>
          <Col span={24}>
            <Divider />
            <h3>
              <FormattedMessageWrapper id="Modifier mon mot de passe" />
            </h3>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              // help={getFieldError('plainPassword') || ''}
              // validateStatus={getFieldError('plainPassword') ? 'error' : ''}
              label={<FormattedMessageWrapper id="Nouveau mot de passe" />}
              labelCol={{ span: 24 }}
              name="plainPassword"
            >
              <InputPassword autoComplete="new-password" />
            </Form.Item>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              // help={getFieldError('plainPasswordConfirmation') || ''}
              // validateStatus={
              //   getFieldError('plainPasswordConfirmation') ? 'error' : ''
              // }
              label={<FormattedMessageWrapper id="Confirmation nouveau mot de passe" />}
              labelCol={{ span: 24 }}
              name="plainPasswordConfirmation"
              rules={[
                form => ({
                  message: <FormattedMessageWrapper id="Confirmation mot de passe incorrecte !" />,
                  validator: (_, value) => {
                    if (value && value !== form?.getFieldValue('plainPassword')) {
                      return Promise.reject();
                    }

                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <InputPassword autoComplete="new-password" />
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Divider />
            <h3>
              <FormattedMessageWrapper id="Préférence linguistique" />
            </h3>
          </Col>
          <Col lg={12} md={24}>
            <Form.Item
              // help={getFieldError('languagePreference') || ''}
              // validateStatus={
              //   getFieldError('languagePreference') ? 'error' : ''
              // }
              label={<FormattedMessageWrapper id="Langue" />}
              labelCol={{ span: 24 }}
              name="languagePreference"
              rules={[
                {
                  message: <FormattedMessageWrapper id="Information manquante" />,
                  required: true,
                },
              ]}
            >
              <Select placeholder="Langue">
                <Option value={FR.value}>{FR.label}</Option>
                <Option value={EN.value}>{EN.label}</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }

  public submit = async () => {
    const { model, onSuccess } = this.props;

    const values = await this.formRef.current?.validateFields();

    const userMe = new UserMeModel();
    userMe.setId(model.id);

    try {
      await userMe.patch({
        email: values.email,
        languagePreference: values.languagePreference,
        plainPassword: values.plainPassword,
        plainPasswordConfirmation: values.plainPasswordConfirmation,
      });

      if (onSuccess) {
        await model.fetch();

        onSuccess(model);
      }
    } catch (error) {
      handleFormError(error, this.formRef.current);
    }
  };
}

export default AccountForm;
